module.exports = __webpack_public_path__ + "img/masterbrandlogoPS.1cb078f3.png";